import { Guide } from "@/pages/catalogs/models/Guide";
import { optionsGuideCode } from "@/shared/selectors/GuideTypeSelector";
import { ErrorModal } from "@dexteel/mesf-core";
import { Grid2, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Part } from "../../models/Part";
import { getGuides } from "../../repositories/parts/GuideRepository";

type useGuidesProps = {
	partId: number;
	onError: (error: Error) => void;
	onSuccess?: (data: Guide[]) => void;
};

export const useGuides = ({ partId, onError, onSuccess }: useGuidesProps) => {
	return useQuery<Guide[], Error>({
		queryKey: ["guides", partId],
		meta: { realtime: ["M2.GetGuides"] },
		queryFn: ({ signal }) => getGuides({ partId }, signal),
		onError: onError,
		onSuccess: onSuccess,
	});
};

type Props = {
	part: Part | null;
};

export const SpecificGuideData = ({ part }: Props) => {
	const [error, setError] = useState("");
	const [guide, setGuide] = useState<Guide>();

	const { data: guides } = useGuides({
		partId: part?.PartId!,
		onError: (error) => setError(error.message),
		onSuccess: (data: Guide[]) => {
			setGuide(data[0]);
		},
	});

	return (
		<>
			<Grid2 container spacing={1}>
				<Grid2 size={{ xs: 12, sm: 12, md: 2 }}>
					<TextField
						value={
							optionsGuideCode.find(
								(type) => type.Code === guide?.GuideTypeCode,
							)?.Name || ""
						}
						label="Type"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12, md: 5 }}>
					<TextField
						value={guide?.Sections || ""}
						label="Sections"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12, md: 5 }}>
					<TextField
						value={guide?.Stands || ""}
						label="Stands"
						variant="outlined"
						size="small"
						fullWidth
						disabled
					/>
				</Grid2>
			</Grid2>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
